import { useRegisterActions } from 'kbar';
import { useCallback, useContext, useMemo } from 'react';
import _ from 'lodash';
import { Brightness4 as BrightnessIcon } from '@mui/icons-material';

import { KBAR_SECTION } from '/common/Kbar/constants';
import { snackbarService } from '/common/snackbarService';
import { ThemeModeContext } from '/common';
import { IThemeModeContext } from '/common/models';

export const ThemeActions = () => {
  const { currentThemeMode, updateThemeMode }: IThemeModeContext = useContext(ThemeModeContext);
  const isDarkMode = useMemo(() => currentThemeMode === 'dark', [currentThemeMode]);

  const updateThemeModeHandler = useCallback(
    (themeMode = isDarkMode) => {
      return themeMode ? updateThemeMode('light') : updateThemeMode('dark');
    },
    [isDarkMode, updateThemeMode]
  );
  useRegisterActions([
    {
      id: 'themeAction',
      name: `Change theme: ${_.capitalize(isDarkMode ? 'light' : 'dark')}`,
      keywords: 'interface color dark light',
      section: KBAR_SECTION.PREFERENCES,
      shortcut: ['t'],
      icon: <BrightnessIcon />,
      perform: () => {
        updateThemeModeHandler();

        snackbarService.custom({
          msg: `${_.capitalize(isDarkMode ? 'light' : 'dark')} theme enabled`,
          type: 'kBarSnackBar',
          buttonText: 'Undo',
          dataTestId: 'undo-button',
          customAction: () => updateThemeModeHandler(!isDarkMode),
        });

        return () => updateThemeModeHandler(!isDarkMode);
      },
    },
  ]);

  return null;
};
